import { Button, Col, Form, Input, Row } from 'antd';
import { useContext } from 'react';
import { NotificationContext } from '../../providers/NotificationProvider';
import { useDispatch } from 'react-redux';
import { recoverPassword } from '../../features/user/userSlice'; // Agrega esta acción en tu Redux slice
import logo from '../../assets/images/logo.png';
import { useNavigate } from 'react-router-dom';
type FieldType = {
  email?: string;
};

const RecoveryPassword: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { triggerNotification } = useContext(NotificationContext);

  const handleSubmit = (values: any) => {
    dispatch(recoverPassword({ email: values.email as string }) as any)
      .then((response: any) => {
        if (recoverPassword.fulfilled.match(response)) {
          triggerNotification(
            'success',
            'Éxito',
            'Te hemos enviado un correo electrónico para restablecer tu contraseña',
            'bottomRight'
          );
        } else {
          triggerNotification('error', 'Error', response.message, 'bottomRight');
        }
      })
      .catch((err: any) => {
        triggerNotification('error', 'Error', err.message, 'bottomRight');
      });
  };

  return (
    <div className='home-login'>
      <Row>
        <Col className='form-login-container'>
          <img src={logo} alt='logo' className='logo' />
          <Form name='recovery' style={{ maxWidth: 600 }} onFinish={handleSubmit} autoComplete='off'>
            <Form.Item<FieldType>
              label='Correo electrónico'
              name='email'
              rules={[{ required: true, message: 'Por favor ingresa tu correo electrónico.' }]}
            >
              <Input />
            </Form.Item>
            <small>
              Al llenar este formulario estás aceptando las políticas de
              <br /> tratamiento de la información que puedes consultar{' '}
              <a target='_blank' href='https://cstrisk.com/privacy-policy/' rel='noreferrer'>
                aquí
              </a>
            </small>
            <br />
            <br />
            <Form.Item>
              <Button type='primary' htmlType='submit'>
                Recuperar contraseña
              </Button>
            </Form.Item>
            <Form.Item>
              <Button
                type='default'
                htmlType='button'
                onClick={() => {
                  navigate('/');
                }}
              >
                Volver
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default RecoveryPassword;
